import React from 'react';
import { DialogManager } from '../../DialogManager';
import { useUser } from '@lore/auth';
import useDialogLauncher from '../../../../hooks/@lore/dialogs-routable/_hooks/useDialogLauncher';
import SecondaryAction from '../../../pages/_components/actions/SecondaryAction';

export default function Header(props) {
  const { networkSite, site, network } = props;

  const launch = useDialogLauncher();
  const currentUser = useUser();

  function onClick() {
    launch(DialogManager.NetworkSiteDelete.Config(networkSite.id));
  }

  return (
    <div className="flex flex-col space-y-2">
      <div className="flex justify-between">
        <div className="space-y-0.5">
          <div className="text-lg font-semibold text-cs-gray-900">
            {network.data.name}
          </div>
          <div className="text-base text-cs-gray-500 line-clamp-3">
            {network.data.city}, {network.data.state}
          </div>
        </div>
        {currentUser.data.isSuperuser && (
          <div className="self-startx">
            <SecondaryAction onClick={onClick} secret={true} disabled={!network}>
              Remove Site
            </SecondaryAction>
          </div>
        )}
      </div>
    </div>
  );
}
